export const restaurants = [
    {
      name: "McDonald's",
      area: "Indiranagar",
      locality: "Cmh Road",
      cuisines: ["Burgers", "Beverages", "Cafe", "Desserts"],
      rating: 4.4,
      costForTwo: "₹400 for two",
      deliveryTime: "30-35 mins",
      image: "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/3/ff52011a-d49c-4809-9b81-01c7eff0a83b_23681.jpg"
    },
    {
      name: "Pizza Hut",
      area: "Koramangala",
      locality: "Maruti Nagar",
      cuisines: ["Pizzas"],
      rating: 4.2,
      costForTwo: "₹300 for two",
      deliveryTime: "35-40 mins",
      image: "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/9/fcc5780a-876e-4605-a3fa-f5e77aaf4588_10582.JPG"
    },
    {
      name: "Olio - The Wood Fired Pizzeria",
      area: "Central Bangalore",
      locality: "Ali Askar Road",
      cuisines: ["Pizzas", "Pastas", "Italian", "Fast Food", "Snacks", "Beverages", "Desserts"],
      rating: 4.4,
      costForTwo: "₹300 for two",
      deliveryTime: "30-35 mins",
      image: "RX_THUMBNAIL/IMAGES/VENDOR/2025/6/17/9981e910-f172-48ba-b08f-c7e5141e7983_770772.JPG"
    },
    {
      name: "Subway",
      area: "Koramangala",
      locality: "Koramangala",
      cuisines: ["sandwich", "Salads", "wrap", "Healthy Food"],
      rating: 4.1,
      costForTwo: "₹350 for two",
      deliveryTime: "30-35 mins",
      image: "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/21/ee36484b-6f43-4f3b-9f73-2a3144355314_93741.JPG"
    },
    {
      name: "Seoul Burgers & Shakes",
      area: "RAJAJINAGAR",
      locality: "6TH BLOCK",
      cuisines: ["Burger", "Bubble Tea", "Fast Food", "Beverages", "Juice and shake"],
      rating: 4.3,
      costForTwo: "₹200 for two",
      deliveryTime: "30-35 mins",
      image: "RX_THUMBNAIL/IMAGES/VENDOR/2024/11/7/82be0d9c-958f-4bf9-bba2-da7d23305885_767218.jpg"
    },
    {
      name: "Boba Bhai - Bubble Tea & Korean Street Food",
      area: "Rajajinagar",
      locality: "Rajajinagar",
      cuisines: ["Bubble Tea", "Burger", "Korean", "Beverages", "Fast Food", "Juice and shake"],
      rating: 4.2,
      costForTwo: "₹200 for two",
      deliveryTime: "35-40 mins",
      image: "RX_THUMBNAIL/IMAGES/VENDOR/2024/11/7/37f756bb-d9c0-4884-a2e3-0f595afe9b31_767216.jpg"
    },
    {
      name: "Crusto's - Cheese Burst Pizza By Olio",
      area: "Central Bangalore",
      locality: "Ali Askar Road",
      cuisines: ["Pizzas", "Pastas", "Italian", "Fast Food", "Snacks", "Beverages", "Desserts"],
      rating: 4.5,
      costForTwo: "₹300 for two",
      deliveryTime: "30-35 mins",
      image: "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/26/afd83212-e410-4093-b8e4-71e5366118c9_770774.jpg"
    },
    {
      name: "McCafe by McDonald's",
      area: "Indiranagar",
      locality: "Indiranagar",
      cuisines: ["Beverages", "Desserts"],
      rating: 4.1,
      costForTwo: "₹250 for two",
      deliveryTime: "35-40 mins",
      image: "RX_THUMBNAIL/IMAGES/VENDOR/2024/8/19/9ca4e46f-7f7d-4fa7-82e8-67fb36a52530_147682.jpg"
    },
    {
      name: "Cupcake Bliss Cake & Desserts",
      area: "R.T. Nagar",
      locality: "Padmavathi Complex",
      cuisines: ["Bakery", "Desserts", "Ice Cream", "Beverages", "Cakes"],
      rating: 4.0,
      costForTwo: "₹200 for two",
      deliveryTime: "35-40 mins",
      image: "40f193d8b23afb2988489dac1258962f"
    },
    {
      name: "The Dessert Zone",
      area: "Vasanth Nagar",
      locality: "Millars Road",
      cuisines: ["Bakery", "Desserts", "Ice Cream", "Beverages", "Cakes"],
      rating: 3.8,
      costForTwo: "₹200 for two",
      deliveryTime: "30-35 mins",
      image: "c447c9ce7d0bbe78e46141e866236762"
    },
    {
      name: "Momo Zone - The Momo Company",
      area: "Vasanth Nagar",
      locality: "Padmavathi Complex",
      cuisines: ["Chinese", "Tibetan", "Fast Food", "Momos"],
      rating: 3.9,
      costForTwo: "₹200 for two",
      deliveryTime: "30-35 mins",
      image: "id5fx1e0ptdvgnyo8rwi"
    },
    {
      name: "Madno - House of Sundaes",
      area: "JP Nagar",
      locality: "2nd Phase",
      cuisines: ["Ice Cream", "Desserts", "Beverages"],
      rating: 4.3,
      costForTwo: "₹250 for two",
      deliveryTime: "30-35 mins",
      image: "RX_THUMBNAIL/IMAGES/VENDOR/2025/3/26/a5e7606d-8d2e-49c2-b89b-ba70e7028ea3_439634.jpg"
    },
    {
      name: "WarmOven Cake & Desserts",
      area: "Vasanth Nagar",
      locality: "Millars Road",
      cuisines: ["Bakery", "Desserts", "Ice Cream", "Beverages", "Cakes"],
      rating: 4.2,
      costForTwo: "₹200 for two",
      deliveryTime: "25-30 mins",
      image: "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/29/d44b4cae-5218-49a6-8e55-76e44f3b0235_402710.JPG"
    },
    {
      name: "Keventers Waffles & Ice Cream",
      area: "Koramangala",
      locality: "7th Block",
      cuisines: ["Ice Cream", "Desserts"],
      rating: 4.6,
      costForTwo: "₹200 for two",
      deliveryTime: "30-35 mins",
      image: "RX_THUMBNAIL/IMAGES/VENDOR/2025/3/20/896f1eb0-53a4-4533-83a8-fe28bcb4f9b9_442032.jpg"
    },
    {
      name: "Kaati Zone Rolls & Wraps",
      area: "Vasanth Nagar",
      locality: "Millars Road",
      cuisines: ["Fast Food", "Bengali", "Beverages", "Desserts", "Rolls"],
      rating: 3.7,
      costForTwo: "₹150 for two",
      deliveryTime: "30-35 mins",
      image: "cv0ebvdyhlxscaz5czpe"
    },
    {
      name: "McDonald's Gourmet Burger Collection",
      area: "Indiranagar",
      locality: "CMH Road",
      cuisines: ["Burgers", "Beverages", "Cafe", "Desserts"],
      rating: 4.3,
      costForTwo: "₹600 for two",
      deliveryTime: "30-35 mins",
      image: "cvmfqvur1saikrlmj8ow"
    },
    {
      name: "Tim Hortons",
      area: "KORAMANGALA",
      locality: "8TH BLOCK",
      cuisines: ["Coffee", "Beverages", "Cafe", "Desserts", "sandwich", "Fast Food"],
      rating: 4.5,
      costForTwo: "₹400 for two",
      deliveryTime: "25-30 mins",
      image: "26c8263d346b308a6a62c003d1d9eca1"
    }
  ];
  
  export const HEADER_URL = "https://www.designevo.com/res/templates/thumb_small/yellow-hamburger-and-wheat.webp";
  
  export const CARD_URL = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
  